/** Task comments in the task pocket: the list and the composer. */
export default {
  comments: "Comments",
  showAll: "Show all",
  you: "You",
  system: "System",
  agent: "Agent",
  toAgent: "to {name}",
  commentAttachment: "Comment attachment",
  screenshot: "Screenshot",
  attachmentLimitTitle: "Attachment limit reached",
  attachmentLimitBody: {
    one: "A comment can include up to {count} file.",
    other: "A comment can include up to {count} files.",
  },
  notSentTitle: "Comment not sent",
  tryAgain: "Please try again.",
  replyTo: "Reply to {name}",
  addComment: "Add a comment",
  comment: "Comment",
  dictate: "Dictate",
  sendComment: "Send comment",
  noAgentsFound: "No agents found",
  attachedFile: "Attached file",
} as const;
